import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import heroVideo from '../assets/hero-banner.mp4';
import heroPoster from '../assets/hero-banner-poster.jpg';

const HeroContainer = styled.section`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 7;
  overflow: hidden;
  background-color: #000;

  @media (max-width: 768px) {
    aspect-ratio: 4 / 5;
  }
`;

const HeroVideo = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const HeroScrim = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 0, 0, 0.15) 55%, rgba(0, 0, 0, 0) 80%);
`;

const HeroOverlay = styled.div`
  position: absolute;
  left: 2.5rem;
  bottom: 3rem;
  width: 20%;
  min-width: 260px;
  color: #fff;
  font-family: 'Plus Jakarta Sans', sans-serif;

  @media (max-width: 768px) {
    width: 80%;
    min-width: unset;
    left: 1.25rem;
    bottom: 1.75rem;
  }
`;

const HeroTitle = styled.h1`
  font-size: clamp(1.875rem, 4vw, 3.25rem);
  font-weight: 800;
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0 0 0.75rem 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);
`;

const HeroSubtitle = styled.p`
  font-size: clamp(0.95rem, 1.2vw, 1.1rem);
  font-weight: 400;
  line-height: 1.4;
  margin: 0 0 1.5rem 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.6);
`;

const HeroButton = styled(Link)`
  display: inline-block;
  color: #f7f2ef;
  background-color: transparent;
  border: 1px solid #f7f2ef;
  border-radius: 8px;
  padding: 0.75rem 1.625rem;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 1.05rem;
  font-weight: 500;
  letter-spacing: -0.01em;
  text-decoration: none;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;

  &:hover {
    background-color: #f7f2ef;
    color: #01183a;
  }
`;

const Hero = () => {
  return (
    <HeroContainer>
      <HeroVideo autoPlay loop muted playsInline poster={heroPoster}>
        <source src={heroVideo} type="video/mp4" />
      </HeroVideo>
      <HeroScrim />
      <HeroOverlay>
        <HeroTitle>The Letter Doctor</HeroTitle>
        <HeroSubtitle>Here for you when it matters the most</HeroSubtitle>
        <HeroButton to="/services">See all products</HeroButton>
      </HeroOverlay>
    </HeroContainer>
  );
};

export default Hero;
